import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter',
  standalone: true
})
export class SearchFilterPipe implements PipeTransform {

  transform(items: any[], searchTerm: string, key: string): any[] {
    if (!items || !searchTerm || !key) {
      return items;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();
    return items.filter(item =>
      item[key]?.toString()?.toLowerCase().includes(lowerSearchTerm)
    );
  }
}